import {CheckGlyph} from '@/components/ui/icons'

/** Sello de éxito de las pantallas públicas: correo verificado, enlace enviado, persona vinculada o cuenta creada. */
export function AuthSeal() {
  return (
    <span
      aria-hidden="true"
      className="flex h-11 w-11 items-center justify-center rounded-full bg-accent text-accent-foreground">
      <CheckGlyph size={20} />
    </span>
  )
}
